import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ROLES } from '@shared/constants/constants';
import { AuthWithMfaDetails } from '../models/auth.model';

export const getAuthFeatureState = createFeatureSelector<AuthWithMfaDetails>('auth');

export const getUserDetail = createSelector(getAuthFeatureState, (state) => ({
  name: state.name,
  email: state.email,
  organization: state.organization,
}));

export const getAuthToken = createSelector(getAuthFeatureState, (state) => state.token);

export const getUserEmail = createSelector(getAuthFeatureState, (state) => state.email);

export const getOrganization = createSelector(getAuthFeatureState, (state) => state.organization);

export const getUserRole = createSelector(getAuthFeatureState, (state): ROLES => state?.role);

export const isSuperAdmin = createSelector(
  getUserRole,
  (role): boolean => role === ROLES.superAdmin
);

export const currentOrganizationAndRole = createSelector(getAuthFeatureState, (authState) => ({
  organization: authState.organization,
  role: authState.role,
}));

export const getMfaDetails = createSelector(
  getAuthFeatureState,
  (authState: AuthWithMfaDetails) => ({
    mfaToken: authState.mfaToken,
    isTotpEnabled: authState.isTotpEnabled,
    authMethod: authState.authMethod,
  })
);
